import { useEffect, useState } from 'react';
import { Background } from '@xyflow/react';

export default function BackgroundPattern({ variant }: { variant: 'none' | 'dots' | 'lines' | 'cross' }) {
	const [mounted, setMounted] = useState(false)
	useEffect(() => {
		const id = requestAnimationFrame(() => setMounted(true))
		return () => cancelAnimationFrame(id)
	}, [])

	if (variant === 'none') return null;
	if (variant === 'dots') return mounted ? <Background /> : null;
	if (variant === 'lines') {
		return mounted ? (
			<svg
				width="100%"
				height="100%"
				style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
			>
				<defs>
					<pattern id="lines" width="24" height="24" patternUnits="userSpaceOnUse">
						<path d="M0 12 H24" stroke="rgba(148,163,184,.35)" strokeWidth="1" />
					</pattern>
				</defs>
				<rect width="100%" height="100%" fill="url(#lines)" />
			</svg>
		) : null;
	}
	return mounted ? (
		<svg
			width="100%"
			height="100%"
			style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
		>
			<defs>
				<pattern id="cross" width="24" height="24" patternUnits="userSpaceOnUse">
					<path
						d="M0 12 H24 M12 0 V24"
						stroke="rgba(148,163,184,.35)"
						strokeWidth="1"
					/>
				</pattern>
			</defs>
			<rect width="100%" height="100%" fill="url(#cross)" />
		</svg>
	) : null;
}